module.exports = __webpack_public_path__ + "static/social-c20dc449fd6c17560ea14ad8d9bade6b.png";